import { useMutation } from '@tanstack/react-query';
import { deleteCapacityLevelRequest } from '../requests/deleteCapacityLevelRequest';
import { queryClient } from '../../../app/App';
import { Alert } from '../../../components/Alert';
import { AxiosError } from 'axios';

export function useDeleteCapacityLevel() {
	const deleteCapacityLevel = useMutation({
		mutationFn: async (id: number) => {
			return deleteCapacityLevelRequest(id);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully deleted!', type: 'success' });
			queryClient.invalidateQueries(['CAPACITY_LEVEL_LIST']);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return {
		deleteCapacityLevel,
	};
}
